/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Back_To_HomeInputs */

const en_back_to_home = /** @type {(inputs: Back_To_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to Home`)
};

const ar_back_to_home = /** @type {(inputs: Back_To_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العودة إلى الصفحة الرئيسية`)
};

const de_back_to_home = /** @type {(inputs: Back_To_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück zu Home`)
};

const es_back_to_home = /** @type {(inputs: Back_To_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volver al inicio`)
};

const fr_back_to_home = /** @type {(inputs: Back_To_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retour à l'accueil`)
};

const it_back_to_home = /** @type {(inputs: Back_To_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Torna alla Home`)
};

const ja_back_to_home = /** @type {(inputs: Back_To_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ホームに戻る`)
};

const ko_back_to_home = /** @type {(inputs: Back_To_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`홈으로 돌아가기`)
};

const pt_br_back_to_home = /** @type {(inputs: Back_To_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltar ao início`)
};

const ru_back_to_home = /** @type {(inputs: Back_To_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`На главную`)
};

const th_back_to_home = /** @type {(inputs: Back_To_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กลับสู่หน้าหลัก`)
};

const tr_back_to_home = /** @type {(inputs: Back_To_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ana sayfaya dön`)
};

const zh_cn_back_to_home = /** @type {(inputs: Back_To_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返回首页`)
};

const zh_tw_back_to_home = /** @type {(inputs: Back_To_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返回首頁`)
};

/**
* | output |
* | --- |
* | "Back to Home" |
*
* @param {Back_To_HomeInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const back_to_home = /** @type {((inputs?: Back_To_HomeInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Back_To_HomeInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_back_to_home(inputs)
	if (locale === "ar") return ar_back_to_home(inputs)
	if (locale === "de") return de_back_to_home(inputs)
	if (locale === "es") return es_back_to_home(inputs)
	if (locale === "fr") return fr_back_to_home(inputs)
	if (locale === "it") return it_back_to_home(inputs)
	if (locale === "ja") return ja_back_to_home(inputs)
	if (locale === "ko") return ko_back_to_home(inputs)
	if (locale === "pt_br") return pt_br_back_to_home(inputs)
	if (locale === "ru") return ru_back_to_home(inputs)
	if (locale === "th") return th_back_to_home(inputs)
	if (locale === "tr") return tr_back_to_home(inputs)
	if (locale === "zh_cn") return zh_cn_back_to_home(inputs)
	return zh_tw_back_to_home(inputs)
});